module.exports = __webpack_public_path__ + "static/img/btn-rules.86235dcf.png";